import React from "react";
import "./LegalTerms.css";
import { Link } from "react-router-dom";

const LegalTerms = () => {
  return (
    <div className="legalTerms-section">
      <div className="legal-header">
        <p>OVest Terms & Conditions</p>
      </div>
      <p className="Terms-text">
        <span>This document is effective from September 1, 2021.</span>
        <br />
        By visiting and signing up on this site, you accept our terms and
        conditions of service.
      </p>
      <p className="legal-texts">
        <p className="legal-content">1.Introduction</p>
        OVest is an automated savings and investment platform available online
        and through mobile applications.
      </p>
      <p className="legal-texts">
        <p className="legal-content">1.1 Purpose</p>
        OVest offer an automated savings and investment service. As our Client,
        your savings and investment will be managed on your behalf in a very low
        cost manner to maximize your returns. By using our website and mobile
        applications, you enter into a series of legally binding agreements. You
        also agree to our Privacy Policy which covers how OVest collect, use,
        share, and store your personal information.
      </p>

      <p className="legal-texts">
        <p className="legal-content">1.2 Agreement</p> When you access our
        website at <Link to="/">www.myovest.com </Link>and/or our mobile application as
        a User and Client, you're agreeing to be bound by the following Terms of
        Use. Please, take time to read the following binding Terms of Use below:
        For the purpose of this agreement, a User is an individual who uses
        OVest Website or mobile application to evaluate our service, or for
        educational purposes and a Client is an individual who signs up on OVest
        and puts in his or her savings and or investment to be managed by OVest.
        This Agreement, as Well as the Privacy Policy applies to both Users and
        Clients. If you become a Client, you will be subject to these Terms of
        Use, our Client Agreement, our Privacy Policy and any additional terms
        to which you agree when you create and fund a savings and or investment
        plan.
        <Link
          to="/terms"
          style={{
            paddingBottom: "50px",
          }}
        >
          <span>..More About Terms And Conditions.</span>
        </Link>
      </p>

      {/* <p className="legal-texts">
        <p>2.Obligations </p>
        <p>
          You must be 18 or older to access our Website or mobile applications.
        </p>
      </p>
      <p className="legal-texts">2.1 Eligibility</p>
      OVest is intended solely for individuals who are 18 or older. Any access
      to or use of OVest by anyone under 18 is unauthorized, unlicensed, and in
      violation of these Terms of Use. By accessing or using OVest, you
      represent and warrant that you are 18 or older.
      <p className="legal-texts">
        3. Disclaimer and Limit of Liability OVest cannot be held responsible
        for any financial insights or recommendations provided to users.
      </p> */}
    </div>
  );
};

export default LegalTerms;
